import React from 'react'
import SingIn from '../Singin/index';
const SinginPage = () => {
    return (
        <>
            <SingIn></SingIn>
        </>
    )
}

export default SinginPage
